import script from "./GroupsManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupsManagement.vue?vue&type=script&setup=true&lang=js"

import "./GroupsManagement.vue?vue&type=style&index=0&id=256827d2&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256827d2"]])

export default __exports__